/**
 * AJ2 · Cómo se usa — giro de la baraja de vídeos.
 *
 * Estado único: `actual` (1..total). Al cambiar: las cartas rotan de
 * posición (data-pos y --aj2-pos, las transiciones las pinta el CSS), el
 * texto del paso activo se muestra, las pestañas marcan aria-selected, el
 * contador se actualiza y el vídeo activo (si lo hay) se reproduce
 * mientras los demás se pausan. El botón de sonido quita el muted del
 * vídeo activo.
 *
 * EL TOTAL ES VARIABLE (1 a 4): sale de las cartas que haya pintado
 * Liquid, nunca de una constante. Los pasos vienen del metaobjeto del
 * producto y cada producto puede tener los suyos.
 *
 * Con UNA sola carta no hay giro, pero el script sí arranca: es quien le da
 * al play al vídeo. Por eso el corte es `total < 1` y no `total < 2`.
 *
 * Sin este script la sección queda con el paso 1 pintado y usable: el giro
 * es mejora progresiva, no requisito.
 */

function iniciarHowto(raiz) {
  let actual = 1;
  let conSonido = false;

  const cartas = [...raiz.querySelectorAll('[data-aj2-carta]')];
  const total = cartas.length;
  if (total < 1) return;
  const pasos = [...raiz.querySelectorAll('[data-aj2-paso]')];
  const tabs = [...raiz.querySelectorAll('[data-aj2-tab]')];
  const contador = raiz.querySelector('[data-aj2-actual]');
  const botonSonido = raiz.querySelector('[data-aj2-sonido]');
  const textoSonido = raiz.querySelector('[data-aj2-sonido-texto]');

  const pintar = () => {
    for (const carta of cartas) {
      const n = Number(carta.dataset.aj2Carta);
      const pos = (n - actual + total) % total;
      carta.dataset.pos = String(pos);
      carta.style.setProperty('--aj2-pos', String(pos));
      const video = carta.querySelector('video');
      if (!video) continue;
      if (n === actual) {
        video.muted = !conSonido;
        video.play().catch(() => {});
      } else {
        video.pause();
        video.muted = true;
      }
    }
    for (const paso of pasos) {
      paso.hidden = Number(paso.dataset.aj2Paso) !== actual;
    }
    for (const tab of tabs) {
      tab.setAttribute('aria-selected', String(Number(tab.dataset.aj2Tab) === actual));
    }
    if (contador) contador.textContent = `0${actual}`;
  };

  const ir = (n) => {
    actual = ((n - 1 + total) % total) + 1;
    pintar();
  };

  for (const tab of tabs) {
    tab.addEventListener('click', () => ir(Number(tab.dataset.aj2Tab)));
  }
  raiz.querySelector('[data-aj2-anterior]')?.addEventListener('click', () => ir(actual - 1));
  raiz.querySelector('[data-aj2-siguiente]')?.addEventListener('click', () => ir(actual + 1));

  for (const carta of cartas) {
    carta.addEventListener('click', () => {
      const n = Number(carta.dataset.aj2Carta);
      if (n !== actual) ir(n);
    });
  }

  botonSonido?.addEventListener('click', () => {
    conSonido = !conSonido;
    botonSonido.setAttribute('aria-pressed', String(conSonido));
    if (textoSonido) {
      textoSonido.textContent = conSonido
        ? botonSonido.dataset.aj2Silenciar || 'Silenciar'
        : botonSonido.dataset.aj2Etiqueta || 'Activar sonido';
    }
    pintar();
  });

  if (botonSonido && textoSonido) {
    botonSonido.dataset.aj2Etiqueta = textoSonido.textContent.trim();
  }

  pintar();
}

function iniciar() {
  for (const raiz of document.querySelectorAll('[data-aj2-howto]')) {
    if (raiz.dataset.aj2Listo) continue;
    raiz.dataset.aj2Listo = '1';
    iniciarHowto(raiz);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', iniciar, { once: true });
} else {
  iniciar();
}

/* En el editor de temas la sección se re-renderiza al tocar un ajuste. */
document.addEventListener('shopify:section:load', iniciar);